// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("BattlePassTier", {
  id: __t.u64(),
  seasonId: __t.u32(),
  tierNumber: __t.u32(),
  freeRewardType: __t.string(),
  freeRewardCoins: __t.i64(),
  freeRewardItemId: __t.option(__t.u64()),
  premiumRewardType: __t.string(),
  premiumRewardCoins: __t.i64(),
  premiumRewardItemId: __t.option(__t.u64()),
});


